import { getDistanceBetweenPoints2D } from './math-utils';
  /**
   * Calculates and creates a AE keyframe ease object.
   *
   * @param prop - property in layer
   * @param keyframeIndex - index of keyframe
   * @param userVars - easing in cubic-bezier notation
   * @returns an array of KeyframeEase objects
   *
   */
export const getBezierInEase = (prop: Property, keyframeIndex: number, userVars: [number, number, number, number]): KeyframeEase[] | undefined => {
    let [ x1, y1, x2, y2 ] = userVars;
    let priorVal = prop.keyValue(keyframeIndex - 1);
    let priorTime = prop.keyTime(keyframeIndex - 1);
    let selectedTime = prop.keyTime(keyframeIndex);
    let selectedVal = prop.keyValue(keyframeIndex);
    if (selectedVal instanceof Array == false && priorVal instanceof Array == false) {
        let distanceBetweenPoints = Math.abs(priorVal - selectedVal);
        let avSpeed = Math.abs(distanceBetweenPoints) / (priorTime - selectedTime);
        let xEaseIn = 100 - x2 * 100;
        let yEaseIn = .1 + (1 - y2) / (1 - x2) * avSpeed;
        let easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
        //if the distance between the points is negative, we need to reverse the ease in and ease out
        if (selectedVal > priorVal) {
            yEaseIn *= -1;
            easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
        }
        return [easeIn];

    } else if (prop.matchName.includes("Position") || prop.matchName.includes("Color") || prop.matchName.includes("Anchor")) {
        let distanceBetweenPoints = getDistanceBetweenPoints2D(priorVal[0], priorVal[1], selectedVal[0], selectedVal[1])
        let avSpeed = Math.abs(distanceBetweenPoints) / (selectedTime - priorTime);
        let inInf = 100 - x2 * 100;
        let inSpd = (1 - y2) / (1 - x2) * avSpeed ;
        let easeIn = getKeyframeEaseObject(inSpd, inInf);
        return [easeIn]
    } else if (selectedVal instanceof Array && priorVal instanceof Array) { 
            let easings = [];
            let easeIn: KeyframeEase;
            let easeOut
            for (let i = 0; i < selectedVal.length; i++) {
                let distanceBetweenPoints = Math.abs(priorVal[i] - selectedVal[i])
                let avSpeed = Math.abs(distanceBetweenPoints) / (priorTime - selectedTime);
                let xEaseOut = x1 * 100;
                let yEaseOut = y1 / x1 * avSpeed;
                let xEaseIn = 100 - x2 * 100;
                let yEaseIn = .1 + (1 - y2) / (1 - x2) * avSpeed;
                if (selectedVal[i] > priorVal[i]) {
                    yEaseOut *= -1;
                    yEaseIn *= -1;
                    easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
                    easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
                } else {
                    easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
                    easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
                }
                easings.push([easeIn, easeOut]);     
            }
            if (prop.value.length == 1) {
                //@ts-ignore
                return [easeIn]
            } else if (prop.value.length == 2) {
                return [easings[0][1], easings[0][1]]
            } else {
                return [easings[0][0], easings[1][0], easings[2][0]];
            }
        }
}

function getKeyframeEaseObject(speed: number, influence: number) {
    if (influence < 0.1) influence = 0.1;
    if (influence > 100) influence = 100;
    return new KeyframeEase(speed, influence);
}

export const getBezierOutEase = (prop: Property, keyframeIndex: number, userVars: [number, number, number, number]) : KeyframeEase[] | undefined => {
    let [ x1, y1, x2, y2 ] = userVars;
    let postTime = prop.keyTime(keyframeIndex + 1);
    let postVal = prop.keyValue(keyframeIndex + 1);
    let selectedTime = prop.keyTime(keyframeIndex);
    let selectedVal = prop.keyValue(keyframeIndex);
    if (selectedVal instanceof Array == false && postVal instanceof Array == false) {
        let distanceBetweenPoints = Math.abs(postVal - selectedVal);
        let avSpeed = Math.abs(distanceBetweenPoints) / (postTime - selectedTime);
        let xEaseOut = x1 * 100;
        let yEaseOut = y1 / x1 * avSpeed;
        let easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
        if (selectedVal > postVal) {
            yEaseOut *= -1;
            easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
        } 
        return [easeOut];
        
    } else if (prop.matchName.includes("Position") || prop.matchName.includes("Color") || prop.matchName.includes("Anchor")) {

        let distanceBetweenPoints = getDistanceBetweenPoints2D(postVal[0], postVal[1], selectedVal[0], selectedVal[1])
        let avSpeed = Math.abs(distanceBetweenPoints) / (postTime - selectedTime);
        let xEaseOut = x1 * 100;
        let yEaseOut = y1 / x1 * avSpeed;
        let easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
        return [easeOut]

    } else if (selectedVal instanceof Array && postVal instanceof Array) { 
            let easings = [];
            let easeIn
            let easeOut: KeyframeEase
            for (let i = 0; i < selectedVal.length; i++) {
                let distanceBetweenPoints = Math.abs(postVal[i] - selectedVal[i])
                let avSpeed = Math.abs(distanceBetweenPoints) / (postTime - selectedTime);
                let xEaseOut = x1 * 100;
                let yEaseOut = y1 / x1 * avSpeed;
                let xEaseIn = 100 - x2 * 100;
                let yEaseIn = .1 + (1 - y2) / (1 - x2) * avSpeed;
                if (selectedVal[i] > postVal[i]) {
                    yEaseOut *= -1;
                    yEaseIn *= -1;
                    easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
                    easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
                } else {
                    easeIn = getKeyframeEaseObject(yEaseIn, xEaseIn);
                    easeOut = getKeyframeEaseObject(yEaseOut, xEaseOut);
                }
                easings.push([easeIn, easeOut]);     
            }
            if (prop.value.length == 1) {
                //@ts-ignore
                return [easeIn]
            } else if (prop.value.length == 2) {
                return [easings[0][1], easings[0][1]]
            } else {
                return [easings[0][0], easings[1][0], easings[2][0]];
            }
        }
}


export const applyBezierToPeak = (prop: Property, peakIdx: number, dstIdx: number, cubicBez:[number, number, number, number]): void => {
        let inEase = getBezierInEase(prop, peakIdx + 1, [ cubicBez[0], cubicBez[1], 1 - cubicBez[0], 1 - cubicBez[1]]);    
        let outEase = getBezierOutEase(prop, peakIdx - 1, [ cubicBez[0], cubicBez[1], 1 - cubicBez[0], 1 - cubicBez[1]]);
        let mirroredPeakEase = getBezierInEase(prop, peakIdx, cubicBez);
        //@ts-ignore
        prop.setTemporalEaseAtKey(peakIdx, mirroredPeakEase, mirroredPeakEase);
        let existingEase = prop.keyInTemporalEase(peakIdx - 1);
        if (peakIdx - 1 !== dstIdx) prop.setTemporalContinuousAtKey(peakIdx - 1, false);
        //@ts-ignore
        prop.setTemporalEaseAtKey(peakIdx - 1, existingEase, outEase);
        //@ts-ignore
        prop.setTemporalEaseAtKey(peakIdx + 1, inEase)

}


export const applyBezierToSingleSelection = (prop: Property, keyframeIndex: number, userVars: [number, number, number, number]): void => {
    if(keyframeIndex === 1) {
        let left = prop.selectedKeys[0]
        let firstSelectedEaseInType = prop.keyInInterpolationType(left);
        let outEase = getBezierOutEase(prop, left, userVars);
        let originalEaseIn = prop.keyInTemporalEase(left);
        //@ts-ignore
        prop.setTemporalEaseAtKey(left, originalEaseIn, outEase);
        if (firstSelectedEaseInType === KeyframeInterpolationType.LINEAR) {
            prop.setInterpolationTypeAtKey(left, KeyframeInterpolationType.LINEAR, KeyframeInterpolationType.BEZIER);
        } else if (firstSelectedEaseInType === KeyframeInterpolationType.HOLD) {
            prop.setInterpolationTypeAtKey(left, KeyframeInterpolationType.HOLD, KeyframeInterpolationType.BEZIER);
        }
    } else if (keyframeIndex === prop.numKeys) {
        let right = prop.selectedKeys[0]
        let lastSelectedEaseOutType = prop.keyOutInterpolationType(right);
        let inEase = getBezierInEase(prop, right, userVars);
        let originalEaseOut = prop.keyOutTemporalEase(right);
        //@ts-ignore
        prop.setTemporalEaseAtKey(right, inEase, originalEaseOut);
    
        if (lastSelectedEaseOutType === KeyframeInterpolationType.LINEAR) {
            prop.setInterpolationTypeAtKey(right, KeyframeInterpolationType.BEZIER, KeyframeInterpolationType.LINEAR);
        } else if (lastSelectedEaseOutType === KeyframeInterpolationType.HOLD) {
            prop.setInterpolationTypeAtKey(right, KeyframeInterpolationType.BEZIER, KeyframeInterpolationType.HOLD);
        }
    } else {
        let outEase = getBezierOutEase(prop, keyframeIndex, [ userVars[0], userVars[1], 1 - userVars[0], 1 - userVars[1]]);
        let inEase = getBezierInEase(prop, keyframeIndex, userVars);
        //@ts-ignore
        prop.setTemporalEaseAtKey(keyframeIndex, inEase, outEase);
    }
}

export const applyBezierToMultipleSelections = (prop: Property, selectedIndices: number[], userVars: [number, number, number, number]) => {
    applyBezierBookends(prop, selectedIndices[0], selectedIndices[selectedIndices.length - 1], userVars)
    for (let i = 1; i < selectedIndices.length - 1; i++) {
        applyBezierToSingleSelection(prop, selectedIndices[i], userVars);
    }
}

//for multiple selections far left and far right keyframe are only out and only in respectively
export const applyBezierBookends = (prop: Property, left: number, right: number, userVars: [number, number, number, number]) => {
    let firstSelectedEaseInType = prop.keyInInterpolationType(left);
    let outEase = getBezierOutEase(prop, left, [userVars[0], userVars[1], 1 - userVars[0], 1 - userVars[1] ]);
    let originalEaseIn = prop.keyInTemporalEase(left);
    //@ts-ignore
    prop.setTemporalEaseAtKey(left, originalEaseIn, outEase);
    let lastSelectedEaseOutType = prop.keyOutInterpolationType(right);
    let inEase = getBezierInEase(prop, right, userVars);
    let originalEaseOut = prop.keyOutTemporalEase(right);
    //@ts-ignore
    prop.setTemporalEaseAtKey(right, inEase, originalEaseOut);

    if (lastSelectedEaseOutType === KeyframeInterpolationType.LINEAR) {
        prop.setInterpolationTypeAtKey(right, KeyframeInterpolationType.BEZIER, KeyframeInterpolationType.LINEAR);
    } else if (lastSelectedEaseOutType === KeyframeInterpolationType.HOLD) {
        prop.setInterpolationTypeAtKey(right, KeyframeInterpolationType.BEZIER, KeyframeInterpolationType.HOLD);
    }
    if (firstSelectedEaseInType === KeyframeInterpolationType.LINEAR) {
        prop.setInterpolationTypeAtKey(left, KeyframeInterpolationType.LINEAR, KeyframeInterpolationType.BEZIER);
    } else if (firstSelectedEaseInType === KeyframeInterpolationType.HOLD) {
        prop.setInterpolationTypeAtKey(left, KeyframeInterpolationType.HOLD, KeyframeInterpolationType.BEZIER);
    }

}